import type { I18n } from "@lingui/core";
import { msg } from "@lingui/macro";

/** Normalizes API slugs (e.g. hair_transplant → hair-transplant) for lookup. */
function normalizeSpecialtySlug(slug: string): string {
  return slug.trim().toLowerCase().replace(/_/g, "-");
}

const SPECIALTY_LABEL_MSG: Record<string, ReturnType<typeof msg>> = {
  vascular: msg`Vascular`,
  fertility: msg`Fertility`,
  bariatric: msg`Bariatric surgery`,
  "bariatric-surgery": msg`Bariatric surgery`,
  wellness: msg`Wellness`,
  "hair-transplant": msg`Hair transplant`,
  "plastic-surgery": msg`Plastic surgery`,
  "diagnostics-imaging": msg`Diagnostics / imaging`,
  dentistry: msg`Dentistry`,
  optical: msg`Optical`,
  "stem-cells": msg`Stem cells`,
  "wellness-healthcare": msg`Wellness & healthcare`,
  orthopedic: msg`Orthopedics`,
  orthopedics: msg`Orthopedics`,
  "neuro-surgery": msg`Neuro surgery`,
  "brain-surgery": msg`Brain surgery`,
  "spine-surgery": msg`Spine surgery`,
  ent: msg`Ear, nose, and throat`,
  "ear-nose-throat": msg`Ear, nose, and throat`,
  "ear-nose-and-throat": msg`Ear, nose, and throat`,
  other: msg`Other`,
};

/**
 * Localized label for a specialty tile. Falls back to API `name` for unknown slugs.
 */
export function displaySpecialtyName(
  slug: string,
  i18n: I18n,
  apiName: string,
): string {
  const key = normalizeSpecialtySlug(slug);
  const md = SPECIALTY_LABEL_MSG[key];
  return md ? i18n._(md) : apiName;
}
